import { createSlice } from "@reduxjs/toolkit";
import ConfigDB from "../../../Config/ThemeConfig";

let initialState = {
  layout_type: "ltr",
  sidebar_types: "compact-wrapper",
  mix_background_layout: "light-only",
  sideBarIconType: "stroke-icon",
  colors: {
    primary_color: "",
    secondary_color: "",
  },
  mixLayout: false,
  sideBarToggle: false,
  margin: 0,
};

const ThemeCustomizerSlice = createSlice({
  name: "ThemeCustomizer",
  initialState,
  reducers: {
    setLayoutType: (state, action) => {
      state.layout_type = action.payload;
      if (action.payload === "rtl") {
        document.body.classList.add("rtl");
        document.body.classList.remove("box-layout", "ltr");
        document.documentElement.dir = "rtl";
      } else if (action.payload === "ltr") {
        document.body.classList.add("ltr");
        document.body.classList.remove("box-layout", "rtl");
        document.documentElement.dir = "ltr";
      } else if (action.payload === "box-layout") {
        document.body.classList.add("box-layout");
        document.body.classList.remove("offcanvas", "rtl", "ltr");
        document.documentElement.dir = "ltr";
      }
    },
    addSidebarTypes: (state, action) => {
      ConfigDB.settings.sidebar.type = action.payload;
      state.sidebar_types = action.payload;
    },
    setSideBarToggle: (state, action) => {
      state.sideBarToggle = action.payload;
    },
    scrollToLeft: (state) => {
      state.margin += 500;
    },
    scrollToRight: (state) => {
      state.margin -= 500;
    },
    addSidebarIconType: (state, action) => {
      ConfigDB.settings.sidebar.iconType = action.payload;
      state.sideBarIconType = action.payload;
    },
    addSideBarBackGround: (state, action) => {
      ConfigDB.color.mix_background_layout = action.payload;
      state.mix_background_layout = action.payload;
      if (action.payload === "light-only") {
        document.body.classList.add("light-only");
        document.body.classList.remove("dark-sidebar","dark-only");
      } else if (action.payload === "dark-only") {
        document.body.classList.add("dark-only");
        document.body.classList.remove("dark-sidebar","light-only");
      } else if (action.payload === "dark-sidebar") {
        document.body.classList.add("dark-sidebar");
        document.body.classList.remove("light-only","dark-only");
      }
    },
    addColor: (state, action) => {
      const colorBackground1 = action.payload;
      const colorBackground2 = action.payload;
      ConfigDB.color.primary_color = colorBackground1;
      ConfigDB.color.secondary_color = colorBackground2;
      state.colors.primary_color = colorBackground1;
      state.colors.secondary_color = colorBackground2;
    },
  },
});

export const { setLayoutType, addSidebarTypes, setSideBarToggle, scrollToLeft, scrollToRight, addSidebarIconType, addSideBarBackGround, addColor } = ThemeCustomizerSlice.actions;

export default ThemeCustomizerSlice.reducer;
